import { observer } from 'mobx-react-lite'
import React, { useCallback, useRef, useState } from 'react'
import { WebView, WebViewProps } from 'react-native-webview'
import { WebViewSourceUri } from 'react-native-webview/lib/WebViewTypes'

import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { useSessionStore } from '@/models/session/useSessionStore'

export const CustomHeaderWebView = observer((props: WebViewProps) => {
  const token = useSessionStore((state) => state.tokenConfig?.accessToken)
  const source = props.source as WebViewSourceUri | undefined
  const sourceWithHeaders: WebViewProps['source'] = source?.uri
    ? ({
        ...source,
        headers: {
          ...(source.headers as Record<string, string> | undefined),
          Authorization: `Bearer ${token}`
        }
      } as WebViewProps['source'])
    : props.source

  return (
    <>
      <StatusBar style={'dark' as StatusBarStyle} />
      {/* <LineProgress color={palette.maroon} isLoading={isLoading} height={2} /> */}
      <WebView
        // ref={webviewRef}
        cacheEnabled={false}
        domStorageEnabled
        incognito={true}
        javaScriptEnabled
        originWhitelist={['*']}
        {...props}
        style={[{ flex: 1 }, props.style]}
        source={sourceWithHeaders}
      />
    </>
  )
})
